import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
//import { FormsModule } from '@angular/forms';   //is this needed here.  can we/should we export from the app module?
import { NgbDatepickerModule, NgbDropdownModule, NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ControlModule } from '@Work/Accounts/proprietary/controls/control.module';
import { FormControlModule } from '@Work/Accounts/proprietary/controls/form-controls/form-control.module';
import { InputControlModule } from '@Work/Accounts/proprietary/controls/input-control.module';
import { TaskControlModule } from '@Work/Accounts/proprietary/controls/task-controls/task-control.module';
import { SharedPageModule } from '@Work/Accounts/proprietary/pages/shared-page.module';
import { EntitySearchDialogModule } from '@Work/Accounts/proprietary/dialogs/entity-search-dialog.module';
import { DocumentFileComponent } from './document-file/document-file.component';
import { DocumentFileEditPanelComponent } from './document-file/panels/document-file-edit-panel/document-file-edit-panel.component';
import { DocumentFilingEditPanelComponent } from './document-file/panels/document-filing-edit-panel/document-filing-edit-panel.component';
import { MultiDocumentFileComponent } from './multi-document-file/multi-document-file.component';
import { MultiDocumentFileEditPanelComponent } from './multi-document-file/panels/multi-document-file-edit-panel/multi-document-file-edit-panel.component';
import { MultiDocumentFilingEditPanelComponent } from './multi-document-file/panels/multi-document-filing-edit-panel/multi-document-filing-edit-panel.component';
import { MultiDocumentInfoEditPanelComponent } from './multi-document-file/panels/multi-document-info-edit-panel/multi-document-info-edit-panel.component';

@NgModule({
    imports: [
        CommonModule,
        //FormsModule,
        FormControlModule,
        SharedPageModule,
        NgbDropdownModule,
        NgbDatepickerModule,
        NgbModalModule,
        NgbTooltipModule,
        InputControlModule,
        TaskControlModule,
        EntitySearchDialogModule,
        ControlModule
    ],
    declarations: [
        DocumentFileComponent,
        DocumentFileEditPanelComponent,
        DocumentFilingEditPanelComponent,
        MultiDocumentFileComponent,
        MultiDocumentInfoEditPanelComponent,
        MultiDocumentFileEditPanelComponent,
        MultiDocumentFilingEditPanelComponent
    ],
    providers: [],
    exports: [
        DocumentFileComponent,
        DocumentFileEditPanelComponent,
        DocumentFilingEditPanelComponent,
        MultiDocumentFileComponent,
        MultiDocumentInfoEditPanelComponent,
        MultiDocumentFileEditPanelComponent,
        MultiDocumentFilingEditPanelComponent,
        //FormsModule,
        FormControlModule,
        InputControlModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DocumentFileModule { }
